module.exports = __webpack_public_path__ + "static/media/calendar.c16ce8bf.svg";